var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#FF6F00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 8C14.6666 11.68 11.6799 14.6667 7.99992 14.6667C4.31992 14.6667 1.33325 11.68 1.33325 8C1.33325 4.32 4.31992 1.33334 7.99992 1.33334C11.6799 1.33334 14.6666 4.32 14.6666 8Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4734 10.12L8.40675 8.88667C8.04675 8.67333 7.75342 8.16 7.75342 7.74V5.00667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidClock);
export default __webpack_public_path__ + "static/media/bfid-clock.31c4a6789ecdffde398155a7acb769a1.svg";
export { ForwardRef as ReactComponent };